import { StateCreator } from 'zustand';

import { OnboardingData, OnboardingSlice } from './types';

const initialState: OnboardingData = {
  firstName: '',
  lastName: '',
  email: '',
  challengeId: '',
  signUpToken: '',
  company: {
    name: '',
    number: '',
    address: '',
    city: '',
    postCode: '',
    country: 'GB',
  },
  nextStep: 'VERIFY_EMAIL',
  termsAcceptedAt: '',
};

const onboardingSlice: StateCreator<OnboardingSlice> = (set) => ({
  onboardingData: initialState,
  isEmailLocked: false,
  setOnboardingData(onboardingData) {
    set((state) => ({
      onboardingData: { ...state.onboardingData, ...onboardingData },
    }));
  },

  setEmailLocked(isLocked) {
    set({ isEmailLocked: isLocked });
  },

  resetOnboardingData() {
    set({ onboardingData: initialState, isEmailLocked: false });
  },
});

export default onboardingSlice;
